<template lang="pug">
  .component-selectize-vehicle
    selectize(v-if="options", :selectedValue="selectedValue", :options="options", value-field="id", :maxItems="maxItems" label-field="plate", :items="items" :searchField="searchableFields", :optionTemplate="optionTemplate", :disabled="disabled", :renderTemplate="renderTemplate", @itemAdded="optionSelected", placeholder="Attributes", @itemRemoved="optionRemoved")
</template>

<script>
  import KeplerBackofficeSdk from "../../../../../lib/kepler/backoffice";
  import BaseSelectize from './BaseSelectize'
  import Selectize from "../../../Selectize";

  export default {
    name: "SelectizeVehicleAttribute",
    extends: BaseSelectize,
    components: {Selectize},
    data() {
      return {
        searchableFields: [
          'id',
          'name',
        ],
      }
    },
    created() {
      KeplerBackofficeSdk.vehicleAttributes.list.all((data) => {
        if (this.filterType) {
          this.options = data.filter((item) => {

            return item.vehicle_type.id === this.filterType
          })
        } else {
          this.options = data
        }
      })
    },
    methods: {
      optionTemplate(item, escape) {
        return `<div><div>VA${item.id} ${item.name}</div><div><small>VT${item.vehicle_type.id} ${item.vehicle_type.name} - ${item.description}</small></div></div>`
      },
      renderTemplate(item, escape) {
        return `<div><div>VT${item.id} ${item.name}</div><div><small>${item.description}</small></div></div>`
      },
      optionsLoader() {

      }
    },
    props: ['selectedValue', 'filterType']
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// SelectizeVehicleAttribute.vue?21200cb7